import Vue from "vue";
import Vuex from "vuex";
import AuthModule from "./modules/Auth.module";
import UserModule from "./modules/User.module";
import ConfigModule from "./modules/Config.module";
import ProjectModule from "./modules/Project.module";
import PlanModule from "./modules/Plan.module";
import MediaModule from "./modules/Media.module";
import CouponModule from "./modules/Coupon.module";
import PassportModule from "./modules/Passport.module";
import SubscriptionModule from "./modules/Subscription.module";
import TrackModule from "./modules/Track.module";

Vue.use(Vuex);

// Helper function to check localStorage for termsAccepted
const getTermsAcceptedFromStorage = () => {
	try {
		const stored = localStorage.getItem('termsAccepted');
		return stored ? JSON.parse(stored) : false;
	} catch (error) {
		console.error('Error reading termsAccepted from localStorage:', error);
		return false;
	}
};

const store = new Vuex.Store({
	state: {
		loading: false,
		barColor: "rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)",
		barImage: "public/assets/ClapWay-light.svg",
		drawer: null,
		termsAccepted: false
	},
	modules: {
		AuthModule,
		UserModule,
		ProjectModule,
		PlanModule,
		ConfigModule,
		PassportModule,
		CouponModule,
		MediaModule,
		SubscriptionModule,
		TrackModule
	},
	mutations: {
		SET_BAR_IMAGE(state, payload) {
			state.barImage = payload;
		},
		SET_DRAWER(state, payload) {
			state.drawer = payload;
		},
		SET_TERMS_ACCEPTED(state, payload) {
			state.termsAccepted = payload;
			localStorage.setItem('termsAccepted', JSON.stringify(payload));
		},
		LOAD_TERMS_ACCEPTED_FROM_STORAGE(state) {
			state.termsAccepted = getTermsAcceptedFromStorage();
		}
	},
	actions: {
		initializeTermsAccepted({ commit }) {
			commit('LOAD_TERMS_ACCEPTED_FROM_STORAGE');
		}
	}
});

// Initialize termsAccepted from localStorage when store is created
store.dispatch('initializeTermsAccepted');

export default store;

export const config = function(key, value) {
	store.commit(ConfigModule.types.SET, {
		key,
		value
	});
};
